import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

export interface BulkDeleteDialogUser {
  id: string;
  name?: string;
  email?: string;
  phone?: string;
  phoneNumber?: string;
  hiddenDate?: string;
}

export interface BulkDeleteHiddenPassengersDialogData {
  mode: 'confirmation' | 'result';
  users?: BulkDeleteDialogUser[];
  queued?: BulkDeleteDialogUser[];
  skipped?: BulkDeleteDialogUser[];
  failed?: BulkDeleteDialogUser[];
}

@Component({
  selector: 'app-bulk-delete-hidden-passengers-dialog',
  templateUrl: './bulk-delete-hidden-passengers-dialog.component.html',
  styleUrl: './bulk-delete-hidden-passengers-dialog.component.scss',
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton],
})
export class BulkDeleteHiddenPassengersDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: BulkDeleteHiddenPassengersDialogData) {}
}
